import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";
import { setDocTitle } from "../../../functions/HelperFuncs";
import i18n from "../../../functions/i18next.js";

export default {
  data() {
    return {
      id: this.$options.name,
      isLoading: true,
      user: this.$store.state.user,
      company: this.$store.state.company,
      company_full: this.$store.state.company_full,
      collections: [],
      showCollectionsCount: false,
      hidetooltip: false,
      actionBtns: {},
    };
  },
  created() {
    setDocTitle("Collections", this);

    this.setActionBtns();

    if (this.company_full.isActive == "trial-expired") {
      location.href = "/" + this.$store.state.company + "/billing";
    } else {
      if (this.user) {
        this.getCollections();
      }

      EventBus.$on("collections", (data) => {
        this.getCollections();
      });

      this.addBtnListeners();
    }
  },
  methods: {
    setActionBtns() {
      this.actionBtns = {
        defaultBtns: [
          {
            name: i18n.t("collection.add_collection"),
            icon: "collect",
            emitterName: `${this.id}-newCollection`,
            emitterData: {},
            rights: ["collect"],
            useMySpace: true,
            showOnMySpace: true,
          },
        ],
        selectedBtns: [],
      };
    },

    addBtnListeners() {
      [...this.actionBtns.defaultBtns, ...this.actionBtns.selectedBtns].forEach(
        (btn) => {
          EventBus.$on(btn.emitterName, () => {
            if (btn.func) {
              btn.func();
            } else {
              this.openRightSidebar(
                btn.emitterName.substring(btn.emitterName.lastIndexOf("-") + 1)
              );
            }
          });
        }
      );
    },
    openRightSidebar(id, data) {
      EventBus.$emit(`right-sidebar-show`, {
        id: id,
        data: data,
      });
    },
    getCollections() {
      this.collections = [];
      this.isLoading = true;

      this.$axios.get(baseUrl + "/collectionsall").then((response) => {
        this.collections = response.data;

        EventBus.$emit("collection-tree-update", this.collections);
        this.isLoading = false;
      });
    },
    hideTooltip() {
      this.hidetooltip = true;
    },

    disableTooltips() {
      let formData = new FormData();
      this.$axios.post(baseUrl + "/hidetooltips", formData).then((response) => {
        let user = localStorage.getItem(
          this.$store.state.company + "_" + "user"
        );
        user = JSON.parse(user);
        user.tooltips = 0;
        localStorage.setItem(
          this.$store.state.company + "_" + "user",
          JSON.stringify(user)
        );
        this.$store.state.user = JSON.parse(
          localStorage.getItem(this.$store.state.company + "_" + "user")
        );
        this.user = this.$store.state.user;
        this.hideTooltip();
      });
    },

    collectionDetail(id) {
      this.$router.push(
        `/${this.$store.state.company}/collection/expanded/${id}`
      );
    },
    openAddCollection(id) {
      EventBus.$emit("openaddcollection", id);
    },
  },
};
